import React from 'react';

import moment from 'moment';

import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Field, FieldArray } from 'redux-form';

import { namespace, actions, selectors } from './';

import wrapMain from '../../wrap-main';

import InputField from '../../../shared/form-elements/input';
import SelectField from '../../../shared/form-elements/select/field';
import DatePicker from '../../../shared/form-elements/date-picker/main';
import { isRequired, isSelected } from '../../../shared/form/validation';

import TemplatesField from '../../components/templates-field';
import TestEmailForm from '../../components/test-email-modal';

import { enum as permissions } from '../../../../../../../enums/admin-permissions';

function MailingEditor({ intl, check, handleSubmit, onSubmit, ...props }) {
	const disabled = !check(permissions.mailingsCreate) || props.isSentAt;
	return (
		<div className='form-container'>
			<div className='form-container__head'>
				<h2 className='icon-edit'>
					{intl('create/edit manual mailing')}
				</h2>
			</div>
			<div className='form-container__body'>
				<form className='mailings-new-form'>
					<div className='mailings-new-form-row'>
						<div className='mailings-new-form-field-from'>
							<Field
								name='from'
								placeholder={intl('From')}
								component={InputField}
								validate={[isRequired]}
								showLabel={false}
								disabled={disabled}
							/>
						</div>
						<div className='mailings-new-form-field-language'>
							<Field
								name='language'
								placeholder={intl('Language')}
								component={SelectField}
								searchable={false}
								multi={false}
								showLabel={false}
								clearable={false}
								options={props.options.languages}
								disabled={disabled}
							/>
						</div>
					</div>
					<div className='mailings-new-form-row'>
						<div className='mailings-new-form-field-segment-name'>
							<Field
								name='segmentName'
								placeholder={intl('Segments')}
								component={SelectField}
								searchable={false}
								multi={false}
								showLabel={false}
								clearable={false}
								options={props.options.segmentNames}
								onChange={props.onSegmentNameChange}
								disabled={disabled}
							/>
						</div>
						{!!props.options.segments.length && (
							<div className='mailings-new-form-field-segment-list'>
								<Field
									name='segments'
									placeholder={intl('Segments')}
									component={SelectField}
									validate={[isSelected]}
									searchable={false}
									multi={true}
									showLabel={false}
									options={props.options.segments}
									disabled={disabled}
								/>
							</div>
						)}
					</div>
					<FieldArray
						name='templates'
						component={TemplatesField}
						intl={intl}
						openTestEmailModal={props.openTestEmailModal}
						disabled={disabled}
					/>
					<TestEmailForm
						intl={intl}
						initialValues={props.testEmailFormInitialValues}
						showTestEmailModal={props.showTestEmailModal}
						toggleTestEmailModal={props.toggleTestEmailModal}
						sendTestEmail={props.sendTestEmail}
						adminsLookup={props.adminsLookup}
					/>
					<div className='mailings-new-form-planner'>
						<Field
							className='mailings-new-form-date-picker'
							name='date'
							component={DatePicker}
							minDate={moment()}
							above
							disabled={disabled}
							onChange={props.onDateChange}
						/>
						<div className='mailings-new-form-field-time'>
							<Field
								name='time'
								placeholder={intl('Time')}
								component={SelectField}
								searchable={false}
								multi={false}
								showLabel={false}
								clearable={false}
								options={props.options.times}
								disabled={disabled}
							/>
						</div>
						<div className='mailings-new-form-field-timezone'>
							<Field
								name='timezone'
								placeholder={intl('Timezone')}
								component={SelectField}
								multi={false}
								showLabel={false}
								clearable={false}
								options={props.timezonesLookup}
								disabled={disabled}
							/>
						</div>
						<button
							className='ui-btn ui-btn-primary'
							type='button'
							onClick={handleSubmit((...data) => onSubmit('send', ...data))}
							disabled={disabled}
						>
							{props.isSendAt ? 'Send at' : 'Send'}
						</button>
						<button
							className='ui-btn ui-btn-primary'
							type='button'
							onClick={handleSubmit((...data) => onSubmit('save', ...data))}
							disabled={disabled}
						>
							Save
						</button>
					</div>
				</form>
			</div>
		</div>
	);
}

const formSelector = formValueSelector(`${namespace}Form`);

function mapStateToProps(state) {
	return {
		initialValues: selectors.select(state, 'data'),
		isLoading: selectors.select(state, 'isLoading'),
		isError: selectors.select(state, 'isError'),
		// -----------------------------------------
		isSentAt: !!formSelector(state, 'sentAt'),
		isSendAt: !!((time) => time && time[0].value)(formSelector(state, 'time')),
		options: selectors.getOptions(state),
		testEmailFormInitialValues: selectors.getTestEmailFormInitialValues(state),
		showTestEmailModal: selectors.select(state, 'showTestEmailModal')
	};
}

const Main = reduxForm({ form: `${namespace}Form`, enableReinitialize: true })(MailingEditor);

export default connect(mapStateToProps, actions.own)(wrapMain(Main));


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/mailings-new/manual-mailings/editor/main.js